/* eslint-disable no-useless-escape */
export function validatePhoneNumber(phone: string) {
  if (!/^[\d\s\-\(\)\+]*$/.test(phone)) return false;

  if ((phone.match(/\+/g) || []).length > 1) return false;
  if (phone.startsWith("+") && phone[1] === "-") return false;

  const open = (phone.match(/\(/g) || []).length;
  const close = (phone.match(/\)/g) || []).length;
  if (open !== close) return false;

  let balance = 0;
  for (const char of phone) {
    if (char === "(") balance++;
    else if (char === ")") balance--;
    if (balance < 0) return false;
  }

  const digitsCount = phone.replace(/\D/g, "").length;
  if (digitsCount > 15 || digitsCount < 3) return false;

  return true;
}
